// extracted by mini-css-extract-plugin
module.exports = {"arrow":"a10a3f92e9--arrow--lWQ6y"};